// --------------------------------------------------------------
// Created On: 2022-09-01
// Author: Zachary Thomas
//
// Last Modified: 2025-02-24
// Modified By: Zachary Thomas
//
// Copyright 2025 © Cornell Pump Company, All Rights Reserved
// --------------------------------------------------------------

// Add a number of days (or subtract with a negative number) to an ISO 8601 UTC string.
export default function isoUtcAddDays(iso: string, days: number): string {
  // Check that ISO string includes timezone info, otherwise assume UTC.
  const isoSplit = iso.split("T");
  if (isoSplit.length > 1) {
    const isoAfterT = isoSplit[1];
    if (!isoAfterT.includes("Z") && !isoAfterT.includes("+") && !isoAfterT.includes("-")) {
      iso += "Z";
    }
  }
  const date = new Date(iso);
  date.setDate(date.getDate() + days);
  return date.toISOString();
}
